import type { ReactElement } from 'react'
import type { MobileDeviceType } from '~/types/device-type'

import Modal from '~/components/Modal'
import { ModalHeader } from '~/components/Modal/Layout'
import AppSelector from '~/views/DynamicScreens/AppSelector'

interface ModalProps {
  isOpen: boolean
  onAppSelectorRowClicked: (app: { app_key: string; device_type: MobileDeviceType }) => void
  onClose: VoidFunction
  selectedApp: {
    id?: string
    name?: string
  }
  title: string
}

const AppSelectorModal = ({
  isOpen,
  onAppSelectorRowClicked,
  onClose,
  selectedApp,
  title,
}: ModalProps): ReactElement => {
  return (
    <Modal className="app-selector-modal" isOpen={isOpen} onCloseModal={onClose}>
      <ModalHeader>{title}</ModalHeader>
      <AppSelector onAppSelectorRowClicked={onAppSelectorRowClicked} selectedApp={selectedApp} />
    </Modal>
  )
}

export default AppSelectorModal
